<template>
  <div>
    <h5>Summary</h5>
    <div :class="`${Loading ? 'disable' : ''}`">
      <div class="border rounded p-1 mb-2">
        <legend class="pl-2 mb-0">Filters:</legend>
        <div
          id="first-row"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 100px;"
          class="rounded"
        >
          <div>
            <div class="d-flex align-items-center p-2">
              <label for="" style="white-space: nowrap;" class="mr-1 mb-0"
                >Clients: <span style="color: red;">*</span></label
              >
              <select
                class="form-control"
                name=""
                id=""
                multiple
                size="7"
                @change="clearBillTo"
                v-model="filters.client_filter_selection"
              >
                <option
                  :value="client"
                  v-for="(client, idx) in clients"
                  :key="idx"
                  >{{ client.name }}</option
                >
              </select>
            </div>
          </div>

          <div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >Bill To: <span style="color: red;">*</span></label
              >
              <select
                class="form-control"
                name=""
                id=""
                style="max-width: 75%;"
                v-model="filters.bill_to"
              >
                <option
                  :value="client"
                  v-for="(client, idx) in filters.client_filter_selection"
                  :key="idx"
                  >{{ client.name }}</option
                >
              </select>
            </div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >Start Date: <span style="color: red;">*</span></label
              >
              <a-date-picker
                format="MM/DD/YYYY"
                id="startDate"
                style="max-width: 75%;"
                v-model="filters.start_date_filter"
                @onChange="updateStartDate"
              />
            </div>
            <div class="d-flex align-items-center p-2">
              <label
                for=""
                style="white-space: nowrap; flex-grow: 1;"
                class="mr-1 mb-0"
                >End Date: <span style="color: red;">*</span></label
              >
              <a-date-picker
                format="MM/DD/YYYY"
                id="endDate"
                v-model="filters.end_date_filter"
                style="max-width: 75%;"
                @onChange="updateEndDate"
              />
            </div>
          </div>
        </div>
        <button class="btn btn-primary m-2 mt-1" type="button" @click="submit">
          Submit
        </button>
      </div>
      <div class="border rounded p-2 mb-2" v-if="local.pdf">
        <p>Your invoice has been successfully generated.</p>
        <p>
          Your Invoice Number is:
          <span style="font-weight: bold;">{{ local.invoiceNumber }}</span>
        </p>
        <p class="mb-0">
          Here is the
          <a
            style="color: #3782f3; text-decoration: underline; cursor: pointer;"
            :href="local.pdf"
            download
            >link</a
          >
          to download your pdf.
        </p>
      </div>
      <div
        class="border rounded p-2 mb-2"
        v-if="getClientByIdData && getTransactionReportData"
      >
        <p
          style="font-weight: bold;"
          class="ml-1"
          v-if="filters.start_date_selected && filters.end_date_selected"
        >
          From {{ moment(filters.start_date_selected).format("MMMM DD, YYYY") }}
          to
          {{ moment(filters.end_date_selected).format("MMMM DD, YYYY") }}
        </p>
        <p
          style="font-weight: bold;"
          class="ml-1"
          v-if="!(filters.start_date_selected && filters.end_date_selected)"
        >
          Please specify the date range.
        </p>
        <div class="border rounded p-2 mb-4" style="display: flex; gap: 15px;">
          <div id="first_half">
            <p style="margin-top: 9px; font-weight: bold;">
              Billed To:
            </p>

            <p style="margin-top: 28px; font-weight: bold;">
              Contact: <span style="color: red;">*</span>
            </p>

            <p style="margin-top: 28px; font-weight: bold;">
              Points consumed:
            </p>
          </div>

          <div id="second_half" style="flex-grow: 1;">
            <p style="margin-top: 9px;">
              {{ getClientByIdData.name }}
            </p>

            <!-- <p style="margin-top: 28px;" v-if="getClientByIdData.taico_email">
              {{ getClientByIdData.taico_email }}
            </p>
            <p
              style="margin-top: 28px; color: grey;"
              v-if="!getClientByIdData.taico_email"
            >
              n/a
            </p> -->
            <input
              type="text"
              class="form-control"
              style="margin-top: 20px; max-width: 45%;"
              name="email"
              id="email"
              placeholder="Email"
              v-model="filters.email"
            />

            <p style="margin-top: 20px;">
              {{
                getTransactionReportData.total_points > 0
                  ? "-" +
                    Math.abs(parseInt(getTransactionReportData.total_points))
                  : Math.abs(parseInt(getTransactionReportData.total_points))
              }}
            </p>
          </div>

          <div id="thrid_half">
            <button
              @click="getTransactions"
              type="button"
              class="btn btn-primary mb-2"
            >
              View Transactions
            </button>
          </div>
        </div>

        <div class="">
          <table
            class="table rounded border table-hover"
            style="border: 1px solid black;"
          >
            <thead style="border-bottom: 1px solid black;">
              <tr>
                <td style="min-width: 90px;"></td>
                <th style="min-width: 385px;">Description</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Amount</th>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(lineitem, idx) in data"
                :key="idx"
                style="border-bottom: 1px solid black;"
              >
                <td class="d-flex align-items-center">
                  <button
                    class="btn btn-danger btn-sm m-1"
                    style="color: white;"
                    type="button"
                    v-if="lineitem.added"
                    @click="removeLineItem(idx)"
                  >
                    -
                  </button>
                </td>
                <td>
                  <input
                    class="form-control"
                    type="text"
                    name=""
                    id=""
                    v-if="lineitem.added"
                    v-model.number="data[idx].desc"
                  />
                  <p class="center" v-if="!lineitem.added">
                    {{ lineitem.desc }}
                  </p>
                  <small v-if="!lineitem.added">
                    {{
                      moment(filters.start_date_selected).format(
                        "MMMM DD, YYYY"
                      )
                    }}
                    -
                    {{
                      moment(filters.end_date_selected).format("MMMM DD, YYYY")
                    }}</small
                  >
                </td>
                <td>
                  <input
                    class="form-control"
                    type="text"
                    name=""
                    id=""
                    v-if="lineitem.added"
                    v-model.number="data[idx].qty"
                  />
                  <p class="center" v-if="!lineitem.added">
                    {{
                      lineitem.qty.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })
                    }}
                  </p>
                </td>

                <td>
                  <input
                    class="form-control"
                    type="text"
                    name=""
                    id=""
                    v-if="lineitem.added"
                    v-model.number="data[idx].price"
                  />
                  <p class="center" v-if="!lineitem.added">
                    {{ formattedString(lineitem.price) }}
                  </p>
                </td>
                <td>
                  <input
                    class="form-control"
                    type="text"
                    name=""
                    id=""
                    v-if="lineitem.added"
                    v-model.number="data[idx].amount"
                  />
                  <p class="center" v-if="!lineitem.added">
                    {{ formattedString(lineitem.amount) }}
                  </p>
                </td>
                <td>
                  <button
                    class="btn btn-primary btn-sm m-1"
                    type="button"
                    v-if="idx === data.length - 1"
                    @click="addNewLineItem"
                  >
                    +
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3"></td>
                <td style="font-weight: bold;">Total</td>
                <td>
                  <span>{{ formattedString(local.runningAmount) }}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div
        class="d-flex justify-content-end"
        v-if="getClientByIdData && getTransactionReportData"
      >
        <button class="btn btn-primary" @click="generateInvoice">
          Generate Invoice
        </button>
      </div>
      <div v-if="Loading === true">
        <div class="centered-spinner">
          <a-spin />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Invoices",
  data() {
    return {};
  },
  watch: {
    data: {
      handler(newValue) {
        this.populateAmount();
      },
      deep: true,
    },
  },
  methods: {
    clearBillTo() {
      this.$store.state.invoices.filters.bill_to = null;
    },
    getTransactions() {
      this.$store.commit("transactions/TOGGLE_TAB", "transactions");

      this.$store.commit("transactions/SET_DATA", {
        getTransactionReportData: this.getTransactionReportData,
        getClientByIdData: this.getClientByIdData,
      });

      this.$store.commit("transactions/SET_FILTERS", {
        client: this.filters.client_selected,
        sDate: this.filters.start_date_selected,
        eDate: this.filters.end_date_selected,
        bill_to: this.filters.bill_to,
      });
    },
    submit() {
      if (!this.filters.client_filter_selection) {
        alert("Please select a client.");
        return;
      }

      if (!this.filters.bill_to) {
        alert("Please select bill to client.");
        return;
      }

      if (!this.filters.start_date_filter || !this.filters.end_date_filter) {
        alert("Please select a date range.");
        return;
      }

      if (
        this.filters.end_date_filter.diff(
          this.filters.start_date_filter,
          "month"
        ) > 6
      ) {
        alert("Date range cannot be more than 6 months.");
        return;
      }

      this.filters.client_selected = this.filters.client_filter_selection;
      this.filters.start_date_selected = this.filters.start_date_filter;
      this.filters.end_date_selected = this.filters.end_date_filter;

      this.$store.commit("invoices/TOGGLE_LOADING");
      this.$store
        .dispatch("invoices/getClientById", {
          clientId: this.filters.bill_to.id,
        })
        .then(() => {
          this.fetchTransactionReportData();
          this.filters.email = this.getClientByIdData.taico_email;
        })
        .catch((err) => alert(err.message))
        .finally(() => {
          this.$store.commit("invoices/TOGGLE_LOADING");
        });

      this.$store.commit("invoices/CLEAR_DATA");
    },
    fetchTransactionReportData() {
      let client_ids = [];

      for (const client of this.filters.client_selected) {
        client_ids.push(client.id);
      }

      this.$store.commit("invoices/TOGGLE_LOADING");
      this.$store
        .dispatch("invoices/getTransactionReport", {
          params: {
            pg_num: 1,
            pg_size: 10,
          },
          data: {
            start_date:
              moment(this.filters.start_date_selected).format("YYYY-MM-DD") +
              "T00:00:00.000Z",
            end_date:
              moment(this.filters.end_date_selected).format("YYYY-MM-DD") +
              "T23:59:59.000Z",
            is_all_clients_selected: false,
            client_ids: client_ids,
            is_all_programs_selected: true,
            program_ids: [],
            is_all_user_code_selected: true,
            user_codes: [],
            is_all_transactions_selected: false,
            show_my_transaction: false,
            transaction_types: ["ORDER", "ORDER TAX", "CREDIT", "CREDIT TAX"],
            show_total: false,
            sort_on: "",
            sub_total_by: ["client"],
            export_to_excel: false,
            email: "",
          },
        })
        .then(() => {
          window.scrollTo(0, document.body.scrollHeight);
          try {
            this.$store.commit("invoices/SET_SUMMARY", {
              ratio:
                this.getClientByIdData.ratio !== null
                  ? this.getClientByIdData.ratio
                  : null,
              clients:
                this.getTransactionReportData.sub_total_details[0].records !==
                null
                  ? this.getTransactionReportData.sub_total_details[0].records
                  : null,
            });
          } catch (error) {
            console.log(error);
          }
        })
        .catch((err) => {
          alert(err.message);
        })
        .finally(() => {
          this.$store.commit("invoices/TOGGLE_LOADING");
        });
    },
    populateAmount() {
      let runningAmount = 0;
      for (const lineItem of this.data) {
        lineItem.amount =
          lineItem.price && lineItem.qty
            ? Number((lineItem.price * lineItem.qty).toFixed(2))
            : 0;

        runningAmount += Number(lineItem.amount.toFixed(2));
      }
      this.local.runningAmount = Number(runningAmount.toFixed(2));
    },
    updateStartDate(date, dateString) {
      this.filters.start_date_filter = dateString;
    },
    updateEndDate(date, dateString) {
      this.filters.end_date_filter = dateString;
    },
    removeLineItem(idx) {
      this.local.runningAmount -= this.data[idx].amount.toFixed(2);
      this.data.splice(idx, 1);
    },
    addNewLineItem() {
      this.data.push({
        desc: "",
        qty: 0,
        price: 0,
        amount: 0,
        added: true,
      });
    },
    generateInvoice() {
      if (!this.filters.client_selected) {
        alert("Please select a client.");
        return;
      }

      if (!this.filters.email) {
        alert("Please provide email in 'Contact' field.");
        return;
      }

      try {
        let invoiceLineItems = [];

        const fullDate = new Date().toJSON().slice(0, 10);

        for (const line of this.data) {
          invoiceLineItems.push({
            DATE: fullDate + "T00:00:00.000Z",
            DESCRIPTION: line.desc,
            EMPLOYEE: this.filters.bill_to.name,
            QUANTITY: line.qty,
            AMOUNT: line.amount,
            UNITPRICE: line.price,
          });

          if (
            typeof line.qty !== "number" ||
            !Number.isInteger(line.qty) ||
            line.qty < 0
          ) {
            alert("Quantity can only take positive integer value.");
            return;
          }

          if (typeof line.price !== "number") {
            alert("Unit price can only be of type number.");
            return;
          }

          // to avoid empty description line items
          if (!line.desc) {
            alert("Line Item description cannot be empty.");
            return;
          }
        }

        console.log(invoiceLineItems);

        this.$store.commit("invoices/TOGGLE_LOADING");
        this.$store
          .dispatch("invoices/getInvoice", {
            CLIENTID: this.filters.bill_to.id,
            CLIENTNAME: this.filters.bill_to.name,
            CLIENTADDRESS: this.getClientByIdData.address1
              ? this.getClientByIdData.address1
              : "",
            CLIENTEMAIL: this.filters.email,
            PERIOD: `${moment(this.filters.start_date_selected).format(
              "MMMM DD, YYYY"
            )}
                  -
                  ${moment(this.filters.end_date_selected).format(
                    "MMMM DD, YYYY"
                  )}`,
            DUEDATE: `${moment()
              .add(30, "d")
              .format("MMMM DD, YYYY")}`,
            INVOICELINEITEMS: invoiceLineItems,
          })
          .then(({ invoiceNumber, invoicePDFURL }) => {
            this.local.invoiceNumber = invoiceNumber;
            window.scroll(0, 0);
            this.local.pdf = invoicePDFURL;
          })
          .catch((err) => {
            alert(err.message);
          })
          .finally(() => {
            this.$store.commit("invoices/TOGGLE_LOADING");
          });
      } catch (error) {
        console.log(error);
      }
    },
    formattedString(num) {
      return Number(num.toFixed(2)) >= 0
        ? "$" +
            Number(num.toFixed(2)).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })
        : "-$" +
            Math.abs(Number(num.toFixed(2))).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            });
    },
  },
  computed: {
    Loading() {
      return this.$store.state.invoices.Loading;
    },
    filters() {
      return this.$store.state.invoices.filters;
    },
    local() {
      return this.$store.state.invoices.local;
    },
    data() {
      return this.$store.state.invoices.data;
    },
    clients() {
      return this.$store.state.invoices.getClientsData;
    },
    getClientByIdData() {
      return this.$store.state.invoices.getClientByIdData;
    },
    getTransactionReportData() {
      return this.$store.state.invoices.getTransactionReportData;
    },
  },
  created() {
    this.$store.commit("invoices/TOGGLE_LOADING");
    this.$store.dispatch("invoices/getClients").finally(() => {
      this.$store.commit("invoices/TOGGLE_LOADING");
    });

    this.$store.commit("invoices/SET_SUMMARY", {
      ratio:
        this.getClientByIdData.ratio !== null
          ? this.getClientByIdData.ratio
          : null,
      clients:
        this.getTransactionReportData.sub_total_details[0].records !== null
          ? this.getTransactionReportData.sub_total_details[0].records
          : null,
    });
  },
};
</script>

<style lang="scss" scoped>
.center {
  margin-top: 10px;
  margin-bottom: 0px;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
